import React from "react";
import { CheckCircle2, FileText, ShieldCheck, Star, Users } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { MOCKUP_URL } from "../data/content";
import { PurchaseCta } from "./PurchaseCta";
const quickBenefits = ["PDF digital", "Acceso inmediato", "Todos los niveles", "Garantía 7 días"];
const socialProof = [{
  icon: Users,
  text: "+300 profes confían"
}, {
  icon: FileText,
  text: "7 Tomos + 5 Bonos"
}, {
  icon: Star,
  text: "4.9/5 valoración"
}, {
  icon: ShieldCheck,
  text: "🇦🇷 Todo el país"
}];
export function Hero() {
  const reduceMotion = useReducedMotion();
  return <header className="relative isolate overflow-hidden border-b border-white/10 bg-[linear-gradient(135deg,#080B14_0%,#0D1424_55%,#080B14_100%)]" data-id="element-95" data-mp="s9q7jpfyirex">
      <div className="pointer-events-none absolute -left-40 top-24 h-96 w-96 rounded-full bg-[#C81724]/15 blur-3xl" data-id="element-96" data-mp="3d1a7phvug7c8" />
      <div className="pointer-events-none absolute -right-32 top-10 h-[34rem] w-[34rem] rounded-full bg-[#F5B83D]/10 blur-3xl" data-id="element-97" data-mp="381xjaspbqs7j" />
      <div className="mx-auto flex w-full max-w-[1180px] flex-col items-center px-5 py-16 text-center sm:px-8 lg:px-12 lg:py-20" data-id="element-98" data-mp="3j9ty8ric7ai4">
        <motion.div className="relative z-10 flex w-full flex-col items-center" initial={reduceMotion ? false : {
        opacity: 0,
        y: 24
      }} animate={reduceMotion ? undefined : {
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.65,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-99" data-mp="3o59dnnvztegn">
          <span className="inline-flex rounded-full border border-[#E3262E]/40 bg-[#C81724]/15 px-4 py-2 text-[10px] font-black uppercase tracking-[0.16em] text-[#FF4650] sm:px-5 sm:text-xs" data-id="element-100" data-mp="30g6kbirzxx6b">
            Atletismo Resuelto™ — Sistema Completo
          </span>
          <h1 className="mt-8 max-w-5xl font-heading text-4xl font-black leading-[0.98] tracking-[-0.055em] text-white sm:text-6xl lg:text-7xl xl:text-[82px]" data-id="element-101" data-mp="2vjq0h0rty4z1">
            Todo tu año de clases de atletismo{" "}
            <span className="inline-block border-b-[6px] border-[#9D2632] pb-1 text-[#E3262E] sm:border-b-8" data-id="element-102" data-mp="2lk8qw89gj6xs">resuelto.</span>
          </h1>

          <motion.div className="relative mx-auto mt-8 aspect-square w-full max-w-[680px] sm:mt-10" initial={reduceMotion ? false : {
          opacity: 0,
          scale: 0.96
        }} animate={reduceMotion ? undefined : {
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.12,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-103" data-mp="nbl4gqm0mqd3">
            <div className="absolute inset-[10%] rounded-full bg-[#C81724]/15 blur-3xl" data-id="element-104" data-mp="1b0dt020b5vxo" />
            <img src={MOCKUP_URL} alt="Mockup premium del sistema digital Atletismo Resuelto con tomos, planillas y materiales para entrenadores de atletismo." className="relative h-full w-full object-contain drop-shadow-[0_28px_45px_rgba(0,0,0,0.65)]" data-id="element-105" data-mp="16345irwhbuch" />
          </motion.div>

          <p className="mt-7 text-lg font-black uppercase tracking-[0.15em] text-[#E3262E] sm:text-xl" style={{
          fontSize: "15px"
        }} data-id="element-106" data-mp="3lquhrx99on9a">Atletismo Resuelto Megapack</p>
          <p className="mt-4 text-lg font-bold text-[#F7F4EC]" data-id="element-107" data-mp="1xam5wruslszg">7 Tomos · 60+ Clases · 5 Bonos · Guías Élite incluidas · Listo para usar.</p>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-[#C7CED8] sm:text-lg" style={{
          fontSize: "14px"
        }} data-id="element-108" data-mp="218jv3uokcf2u">
            Tu año completo de clases de atletismo listo: fundamentos, velocidad, medio fondo, fondo, saltos, lanzamientos, planificación, evaluación y mucho más. Sin improvisar nunca más.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-109" data-mp="2kyduattlxwh3">
            {quickBenefits.map(benefit => <span key={benefit} className="inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/[0.04] px-3 py-2 text-xs font-semibold text-[#F7F4EC]" data-id="element-110" data-mp="2p1jylvx5tdkx">
                <CheckCircle2 className="size-4 text-[#27B36A]" aria-hidden="true" data-id="element-111" data-mp="umpt0a2ni12p" />{benefit}
              </span>)}
          </div>
          <PurchaseCta className="mt-8" data-id="element-112" data-mp="zm2n9fvuqafb" />
        </motion.div>
      </div>
      <div className="border-t border-white/10 bg-[#080B14]/80" data-id="element-113" data-mp="4akz14d7suim">
        <div className="mx-auto grid max-w-[1400px] grid-cols-2 divide-x divide-y divide-white/10 px-5 sm:grid-cols-4 sm:divide-y-0 lg:px-12" data-id="element-114" data-mp="3vhp61z9d0gr1">
          {socialProof.map(({
          icon: Icon,
          text
        }) => <div key={text} className="flex items-center justify-center gap-2 px-3 py-5 text-center text-xs font-bold text-[#F7F4EC] sm:text-sm" data-id="element-115" data-mp="9ah3f4ptqnyp">
              <Icon className="size-4 text-[#F5B83D]" aria-hidden="true" data-id="element-116" data-mp="3hr25e1k1ggsb" />{text}
            </div>)}
        </div>
      </div>
    </header>;
}